module.exports = __webpack_public_path__ + "img/theme_default.5112da12.png";